<template>
  <div>
    <DropUpload
      :configdata="configdata"
      :jobcount="countMailbox"
      :incart="jobsInCart"
      @add-uploaded-jobs="addUploadedJobs"
      @upload-files-error="uploadFilesError"
      @show-spinner-modal="showSpinnerModal"
    />
    <div class="block">
      <!-- Mailbox Mobile Navigation -->
      <div class="mailbox__navigation--mobile">
        <div class="mailbox-navigation-items-wrapper">
          <div class="mailbox-navigation-items-right">
            <div
              :class="{
                'disabled__overlay--wrapper disabled__overlay--basket': true,
                'disabled__overlay--active': cartIsEmpty()
              }"
            >
              <div class="disabled__overlay"></div>
              <a class="cta cta--medium" :href="this.config.routes.ebrief_cart">
                <span class="cta__wrapper">
                  <span class="cta__icon"> &#xeaa0; </span>
                  <span class="cta__text">
                    <span class="cta--bold">{{
                      this.config.lang["mailbox.to_cart_button"]
                    }}</span>
                  </span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!-- Mailbox Mobile Navigation End -->
      <div class="block__content mailbox__block mailbox">
        <h3 class="mailbox__headline-text">
          Diese Briefe <span class="h3--bold">wurden hochgeladen</span
          ><span v-show="this.countMailbox > 0"
            >&nbsp;({{ this.countMailbox }})</span
          >
        </h3>
        <!-- Mailbox Desk Navigation -->
        <div class="mailbox__headline">
          <div class="headline-item-left">
            <div
              id="delete-all-link"
              :class="{
                'disabled__overlay--wrapper disabled__overlay--delete': true,
                'disabled__overlay--active': jobsNotPresent
              }"
            >
              <div class="disabled__overlay"></div>
              <a href="javascript:void(0);" @click.prevent="deleteAllJobs()">
                <i class="icofont-trash"></i>
                {{ this.config.lang["mailbox.delete_all"] }}
              </a>
            </div>
            <div
              id="add-all-link"
              :class="{
                'disabled__overlay--wrapper disabled__overlay--add-all': true,
                'disabled__overlay--active': readyJobsNotPresent()
              }"
            >
              <div class="disabled__overlay"></div>
              <a
                class="mailbox__iconlink_basketall"
                href="javascript:void(0);"
                @click.prevent="pushReadyToCart()"
              >
                {{ this.config.lang["mailbox.add_all"] }}
              </a>
            </div>
          </div>
          <div class="headline-item-right">
            <div class="item-right--button">
              <div
                :class="{
                  'disabled__overlay--wrapper disabled__overlay--basket': true,
                  'disabled__overlay--active': cartIsEmpty()
                }"
              >
                <div class="disabled__overlay"></div>
                <a
                  class="cta cta--medium"
                  :href="this.config.routes.ebrief_cart"
                >
                  <span class="cta__wrapper">
                    <span class="cta__icon">
                      <i class="icofont-basket"></i>
                    </span>
                    <span class="cta__text">
                      <span class="cta--bold">{{
                        this.config.lang["mailbox.to_cart_button"]
                      }}</span>
                    </span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <!-- Mailbox Desk Navigation End -->
        <div
          :class="{
            mailbox__empty: true,
            'mailbox__empty--is-empty': jobsNotPresent
          }"
          v-html="this.config.lang['account.jobs.empty']"
        ></div>
        <MailboxJob
          v-for="job in jobs"
          :key="job.pid"
          :configdata="configdata"
          :pid="job.pid"
          :job="job"
          @add-job-to-cart="addJobToCart"
          @remove-job="editJobDelete"
          @edit-job="editJob"
          @preview-job="previewJob"
          @reload-job="reloadJob"
        />
      </div>
    </div>
    <transition name="modalfade">
      <EditControl
        v-show="isEditModalVisible"
        :configdata="configdata"
        :jobpid="editJobPid"
        @edit-job-close="editJobClose"
        @edit-job-delete="editJobDelete"
        @edit-job-edit="editJobEdit"
        @show-spinner-modal="showSpinnerModal"
      />
    </transition>
    <transition name="modalfade">
      <JobPreview
        v-show="isPreviewModalVisible"
        :configdata="configdata"
        :jobpid="previewJobPid"
        @preview-loaded="previewLoaded"
        @preview-job-close="previewJobClose"
        @preview-job-accept="previewJobAccept"
        @preview-job-delete="previewJobDelete"
        @show-spinner-modal="showSpinnerModal"
        @show-error="showErrorMessage"
      />
    </transition>
    <transition name="modalfade">
      <ErrorModal
        v-show="isErrorModalVisible"
        :error="this.modalError"
        @close-error-message="closeErrorMessage"
      />
    </transition>
    <transition name="modalfade">
      <SpinnerModal v-show="isSpinnerModalVisible" />
    </transition>
  </div>
</template>

<script>
import JobService from "../services/JobService";
import MailboxJob from "./MailboxJob";
import DropUpload from "./DropUpload";
import SpinnerModal from "./SpinnerModal";
import EditControl from "./EditControl";
import JobPreview from "./JobPreview";
import ErrorModal from "./ErrorModal";

export default {
  name: "Mailbox",
  components: {
    DropUpload,
    MailboxJob,
    SpinnerModal,
    EditControl,
    JobPreview,
    ErrorModal
  },
  props: {
    configdata: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      jobs: {},
      jobsInCart: 0,
      sharedJobData: {
        data: {}
      },
      loadPreviewModal: false,
      editJobPid: undefined,
      previewJobPid: undefined,
      isErrorModalVisible: false,
      isSpinnerModalVisible: true,
      isEditModalVisible: false,
      isPreviewModalVisible: false,
      dragAndDropCapable: false,
      refreshTimer: null,
      refreshInterval: 3000,
      modalError: {
        title: configdata.lang["modal.control.error-title"],
        header: "",
        message: "",
        button: configdata.lang["modal.control.error-button"]
      }
    };
  },
  computed: {
    config: function() {
      if (configdata.userType == "anonymous") {
        this.isSpinnerModalVisible = false;
      }
      return configdata;
    },
    jobsReadyPids: function() {
      let jobs = this.jobs;
      let jobsReadyPids = [];
      Object.keys(jobs).forEach(key => {
        if (jobs[key].frontendstatus === "success") {
          jobsReadyPids.push(jobs[key].pid);
        }
      });
      return jobsReadyPids;
    },
    countMailbox: function() {
      return Object.keys(this.jobs).length;
    },
    jobsNotPresent: function() {
      return this.countMailbox < 1;
    }
  },
  methods: {
    cartIsEmpty() {
      return this.jobsInCart < 1;
    },
    readyJobsNotPresent() {
      return this.jobsReadyPids.length < 1;
    },
    getCreated() {
      JobService.getCreated(
        this.config.routes["ebrief_mailbox_data"],
        this.config.routes["ebrief_cart_count"]
      ).then(response => {
        this.jobs = response.jobs;
        this.jobsInCart = response.cart;
        this.isSpinnerModalVisible = false;
      });
    },
    fetchJob(job) {
      JobService.fetchJob(this.config.routes["ebrief_fetch_job"], {
        jobId: job.pid
      }).then(response => {
        this.isSpinnerModalVisible = false;
      });
    },
    countCart() {
      JobService.countCart(this.config.routes["ebrief_cart_count"]).then(
        response => {
          this.jobsInCart = response.cartcount;
          this.updateCartButton();
        }
      );
    },
    addUploadedJobs(update) {
      let that = this;
      //this.jobs = Object.assign({}, this.jobs, update);
      Object.keys(update).forEach(key => {
        let currentJob = that.jobs[key];
        if (typeof currentJob === "undefined") {
          if (this.countMailbox > 0) {
            let ukey = update[key].pid;
            this.$set(this.jobs, ukey, update[key]);
          } else {
            let insert = {};
            insert[update[key].pid] = update[key];
            this.jobs = Object.assign(insert);
          }
        }
      });
      this.isSpinnerModalVisible = false;
    },
    uploadFilesError() {
      this.modalError.header = this.config.lang[
        "ebrief.error.file_upload_failed.header"
      ];
      this.modalError.message = this.config.lang[
        "ebrief.error.file_upload_failed.text"
      ];
      this.isSpinnerModalVisible = false;
      this.isErrorModalVisible = true;
    },
    pushReadyToCart() {
      let that = this;
      this.isSpinnerModalVisible = true;
      JobService.addAllJobsToCart(
        this.config.routes["ebrief_add_all_to_cart"]
      ).then(response => {
        if (response.put.length > 0) {
          response.put.forEach(function(pid) {
            that.$delete(that.jobs, pid);
          });
          this.jobsInCart = response.cartQuantity;
          this.updateCartButton();
          if (response.fails.length > 0) {
            this.modalError.header = this.config.lang[
              "ebrief.error.job_addalltocart_failed.header"
            ];
            this.modalError.message = this.config.lang[
              "ebrief.error.job_addalltocart_failed.text"
            ];
            this.isErrorModalVisible = true;
          }
        }
        if (response.put.length === 0 && response.fails.length > 0) {
          this.modalError.header = this.config.lang[
            "ebrief.error.job_addalltocart0_failed.header"
          ];
          this.modalError.message = this.config.lang[
            "ebrief.error.job_addalltocart0_failed.text"
          ];
          this.isErrorModalVisible = true;
        }
        this.isSpinnerModalVisible = false;
      });
    },
    addJobToCart(job) {
      if (job.frontendstatus === "success") {
        this.isSpinnerModalVisible = true;
        let data = {
          jobId: job.id
        };
        JobService.addJobToCart(
          this.config.routes["ebrief_add_to_cart"],
          data
        ).then(response => {
          this.isSpinnerModalVisible = false;
          if (response.success) {
            this.jobsInCart++;
            this.updateCartButton();
            this.$delete(this.jobs, job.pid);
          } else {
            this.modalError.header = error.header;
            this.modalError.message = error.text;
            this.isErrorModalVisible = true;
          }
        });
      } else {
        console.error("job not ready for cart");
      }
    },
    deleteAllJobs() {
      this.isSpinnerModalVisible = true;
      JobService.deleteAllJobsFromMailbox(
        this.config.routes["ebrief_clear_mailbox"]
      ).then(response => {
        this.isSpinnerModalVisible = false;
        if (response?.success) {
          this.jobs = {};
        } else {
          this.modalError.header = response.error.header;
          this.modalError.message = response.error.text;
          this.isErrorModalVisible = true;
        }
      });
    },
    editJob(job) {
      this.isEditModalVisible = true;
      this.editJobPid = job.pid;
    },
    editJobClose() {
      this.isEditModalVisible = false;
      this.editJobPid = undefined;
    },
    editJobDelete(pid) {
      this.isSpinnerModalVisible = false;
      this.isEditModalVisible = false;
      this.editJobPid = undefined;
      let data = {
        jobId: this.jobs[pid].id
      };
      JobService.deleteJobFromMailbox(
        this.config.routes["ebrief_job_cancellation"],
        data
      ).then(response => {
        this.isSpinnerModalVisible = false;
        if (response.success) {
          this.$delete(this.jobs, pid);
        } else {
          this.modalError.header = error.header;
          this.modalError.message = error.text;
          this.isErrorModalVisible = true;
        }
      });
    },
    editJobEdit(error) {
      this.isSpinnerModalVisible = false;
      if (error) {
        this.modalError.header = error.header;
        this.modalError.message = error.text;
        this.isErrorModalVisible = true;
      }
    },
    previewJob(job) {
      this.previewJobPid = job.pid;
      this.isSpinnerModalVisible = true;
      this.loadPreviewModal = true;
    },
    previewLoaded() {
      this.isSpinnerModalVisible = false;
      this.isPreviewModalVisible = true;
    },
    previewJobClose() {
      this.isPreviewModalVisible = false;
      this.previewJobPid = undefined;
      this.clearLoads();
    },
    previewJobAccept(error) {
      this.isSpinnerModalVisible = false;
      if (error) {
        this.modalError.header = error.header;
        this.modalError.message = error.text;
        this.isErrorModalVisible = true;
      }
      this.clearLoads();
    },
    previewJobDelete(pid) {
      this.isPreviewModalVisible = false;
      let data = {
        jobId: this.jobs[pid].id
      };
      JobService.deleteJobFromMailbox(
        this.config.routes["ebrief_job_cancellation"],
        data
      ).then(response => {
        this.isSpinnerModalVisible = false;
        if (response.success) {
          this.$delete(this.jobs, pid);
        } else {
          this.modalError.header = error.header;
          this.modalError.message = error.text;
          this.isErrorModalVisible = true;
        }
      });
      this.clearLoads();
    },
    showErrorMessage(message) {
      this.modalError.header = message.header;
      this.modalError.message = message.text;
      this.isSpinnerModalVisible = false;
      this.isErrorModalVisible = true;
    },
    closeErrorMessage() {
      this.isErrorModalVisible = false;
      this.clearLoads();
    },
    clearLoads() {
      this.loadPreviewModal = false;
      this.editJobPid = undefined;
      this.previewJobPid = undefined;
    },
    showSpinnerModal() {
      this.isSpinnerModalVisible = true;
    },
    updateCartButton() {
      let disabledOverlayBasket = $(".disabled__overlay--basket");
      let basketCountJobs = $("#basket-count-jobs");
      let basketText = $(".basket__text");
      disabledOverlayBasket.removeClass("disabled__overlay--active");
      basketCountJobs
        .removeClass("basket__count-jobs--empty")
        .text(this.jobsInCart);
      basketText.removeClass("basket__text--empty");
      if (this.jobsInCart <= 0) {
        disabledOverlayBasket.addClass("disabled__overlay--active");
        basketCountJobs.addClass("basket__count-jobs--empty");
        basketText.addClass("basket__text--empty");
      }
    },
    reloadJob(job) {
      this.isSpinnerModalVisible = true;
      this.fetchJob(job);
    },
    setupStream() {
      let that = this;
      let eventSourceCallback = new EventSource(
        that.config.routes["mercure_callback_url"],
        { withCredentials: true }
      );
      eventSourceCallback.addEventListener(
        "message",
        event => {
          let updatedJob = JSON.parse(event.data);
          let currentJob = that.jobs[updatedJob.pid];
          if (typeof currentJob !== "undefined") {
            this.$set(currentJob, "version", updatedJob.version);
            this.$set(currentJob, "portalstatus", updatedJob.portalstatus);
            this.$set(currentJob, "frontendstatus", updatedJob.frontendstatus);
            this.$set(currentJob, "jobInfo", updatedJob.jobInfo);
            this.$set(currentJob, "logicalPages", updatedJob.logicalPages);
            this.$set(currentJob, "physicalPages", updatedJob.physicalPages);
            this.$set(currentJob, "recipients", updatedJob.recipients);
            this.$set(currentJob, "jobError", updatedJob.jobError);
            this.$set(currentJob, "printType", updatedJob.printType);
            this.$set(currentJob, "colorType", updatedJob.colorType);
            this.$set(currentJob, "shipmentType", updatedJob.shipmentType);
            this.$set(currentJob);
            // this.$set(
            //   currentJob,
            //   "shipmenttypemodifier",
            //   updatedJob.shipmenttypemodifier
            // );
            if (updatedJob.returnEnvelopeType) {
              this.$set(
                currentJob,
                "returnEnvelopeType",
                updatedJob.returnEnvelopeType
              );
              this.$set(currentJob, "returnAddress", updatedJob.returnAddress);
            }
            this.$set(currentJob, "priceBrutto", updatedJob.priceBrutto);
          } else if (
            updatedJob.portalstatus === "USER_WAIT_FOR_SHOPPING" ||
            updatedJob.portalstatus === "USER_CONFIRMATION_REQUESTED"
          ) {
            if (this.countMailbox > 0) {
              let key = updatedJob.pid;
              that.$set(that.jobs, key, updatedJob);
            } else {
              let update = {};
              update[updatedJob.pid] = updatedJob;
              that.jobs = Object.assign(update);
            }
          }
        },
        false
      );
    }
  },
  created() {
    this.getCreated();
    this.setupStream();
  }
};
</script>
